import {
    Box,
    Button,
    Grid,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@material-ui/core";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import React, { useEffect, useState } from "react";
import { useFieldArray } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { isEmpty, isNotEmpty, isObjectNotEmpty } from "../../../Utils";
import CustomCheckBox from "../../../inputComponent/CustomCheckBox/CustomCheckBox";
import CustomSelect from "../../../inputComponent/CustomSelect/CustomSelect";
import "./subjectTable.scss";

export default function subjectTable({
    classes,
    control,
    register,
    jobIndex,
    defaultValues,
    setValue,
    getValues,
    setDisablePostAddBtn,
}) {
    const { t, i18n } = useTranslation();

    const jobTitle = getValues(`job.${jobIndex}.jobTitle`);

    const optionsList = getValues(
        `jobApplication${i18n.language?.toUpperCase()}`
    );

    const initJobOptions = optionsList?.jobOptions || {};

    const initSubjectOptions = isEmpty(jobTitle)
        ? {}
        : optionsList?.[`${jobTitle}Options`] || {};

    const [jobOptions, setJobOptions] = useState(initJobOptions);
    const [subjectOptions, setSubjectOptions] = useState(initSubjectOptions);

    const { fields, remove, append } = useFieldArray({
        control,
        name: `job.${jobIndex}.subjectList`,
    });

    const [specialEducationSubject, setSpecialEducationSubject] = useState([]);
    const [nonSpecialEducationSubject, setNonSpecialEducationSubject] =
        useState([]);

    const renderSubject = (subject, subjectIndex) => {
        return (
            <TableRow key={subject.id}>
                <TableCell
                    width={"30%"}
                    align="center"
                    className={classes.subjectRow}
                >
                    <CustomSelect
                        inlineText
                        control={control}
                        fullWidth
                        defaultValue={
                            defaultValues?.job?.[jobIndex]?.subjectList?.[
                                subjectIndex
                            ]?.subjectName
                        }
                        name={`job.${jobIndex}.subjectList.${subjectIndex}.subjectName`}
                        inputProps={{
                            ...register(
                                `job.${jobIndex}.subjectList.${subjectIndex}.subjectName`,
                                {
                                    required: t("errorMsg.required"),
                                    validate: {
                                        DuplicatesSubject: (subjectName) => {
                                            const subjectList = getValues(
                                                `job.${jobIndex}.subjectList`
                                            );
                                            return (
                                                subjectList?.filter(
                                                    (subject) =>
                                                        subject?.subjectName ===
                                                        subjectName
                                                )?.length <= 1 ||
                                                t(
                                                    "Form101.errorMsg.duplicatesSubject"
                                                )
                                            );
                                        },
                                    },
                                }
                            ),
                        }}
                        options={subjectOptions}
                        required={false}
                        onChange={(event) => {
                            const value = event?.target?.value;
                            setValue(
                                `job.${jobIndex}.subjectList.${subjectIndex}.subjectName`,
                                value,
                                {
                                    shouldValidate: true,
                                }
                            );
                        }}
                    />
                </TableCell>
                <TableCell
                    width={"10%"}
                    style={{
                        margin: "auto",
                    }}
                    className={classes.subjectRow}
                >
                    <CustomCheckBox
                        required={false}
                        control={control}
                        textAlign={"center"}
                        name={`job.${jobIndex}.subjectList.${subjectIndex}.hasEnglish`}
                        boxStyle={{
                            margin: 0,
                            width: "100%",
                        }}
                        labelStyle={{ margin: "auto" }}
                    />
                </TableCell>
                <TableCell
                    width={"10%"}
                    align="center"
                    className={classes.subjectRow}
                >
                    <CustomCheckBox
                        required={false}
                        control={control}
                        name={`job.${jobIndex}.subjectList.${subjectIndex}.hasAEO`}
                        boxStyle={{
                            margin: 0,
                            width: "100%",
                        }}
                        labelStyle={{ margin: "auto" }}
                    />
                </TableCell>
                <TableCell
                    width={"10%"}
                    align="center"
                    className={classes.subjectRow}
                >
                    <CustomCheckBox
                        required={false}
                        control={control}
                        name={`job.${jobIndex}.subjectList.${subjectIndex}.hasMath`}
                        boxStyle={{
                            margin: 0,
                            width: "100%",
                        }}
                        labelStyle={{ margin: "auto" }}
                    />
                </TableCell>
                <TableCell
                    width={"10%"}
                    align="center"
                    className={classes.subjectRow}
                >
                    <CustomCheckBox
                        required={false}
                        control={control}
                        name={`job.${jobIndex}.subjectList.${subjectIndex}.hasPutonghua`}
                        boxStyle={{
                            margin: 0,
                            width: "100%",
                        }}
                        labelStyle={{ margin: "auto" }}
                    />
                </TableCell>
                <TableCell
                    width={"5%"}
                    align="center"
                    className={classes.subjectRow}
                >
                    <IconButton
                        color="primary"
                        onClick={() => {
                            remove(subjectIndex);
                        }}
                    >
                        <RemoveCircleIcon />
                    </IconButton>
                </TableCell>
            </TableRow>
        );
    };

    useEffect(() => {
        const optionsList = getValues(
            `jobApplication${i18n.language?.toUpperCase()}`
        );
        const jobOptions = optionsList?.jobOptions || {};

        const updateSubjectOptions = isEmpty(jobTitle)
            ? {}
            : optionsList?.[`${jobTitle}Options`] || {};

        setJobOptions(jobOptions);
        setSubjectOptions(updateSubjectOptions);
    }, [i18n.language]);

    useEffect(() => {
        if (getValues(`job.${jobIndex}.jobTitle`) === "AIG") {
            setSpecialEducationSubject(
                fields
                    ?.map((subject, index) => {
                        return { ...subject, currentIndex: index };
                    })
                    ?.filter((subject) => subject?.isSpecial === true)
            );
            setNonSpecialEducationSubject(
                fields
                    ?.map((subject, index) => {
                        return { ...subject, currentIndex: index };
                    })
                    ?.filter((subject) => subject?.isSpecial === false)
            );
            const removeIndex = fields?.findIndex((subject) =>
                isEmpty(subject.id)
            );
            if (removeIndex > -1) {
                remove(removeIndex);
            }
        }
    }, [fields]);

    return (
        <>
            <Box mt={2}>
                <Grid container>
                    <Grid item xs={2} className={classes.label}>
                        {t("Form101.label.jobTitle") + t("common.colon")}
                    </Grid>
                    <Grid item xs={8}>
                        <CustomSelect
                            inlineText
                            control={control}
                            defaultValue={
                                defaultValues?.job?.[jobIndex]?.jobTitle
                            }
                            name={`job.${jobIndex}.jobTitle`}
                            inputProps={{
                                ...register(`job.${jobIndex}.jobTitle`, {
                                    required: t("errorMsg.required"),
                                }),
                            }}
                            options={jobOptions}
                            onChange={(event) => {
                                const value = event?.target?.value;
                                setValue(`job.${jobIndex}.jobTitle`, value);
                                setSubjectOptions(
                                    optionsList?.[`${value}Options`] || {}
                                );
                                setValue(
                                    `job.${jobIndex}.subjectList`,
                                    isNotEmpty(
                                        optionsList?.[`${value}Options`]
                                    ) &&
                                        isObjectNotEmpty(
                                            optionsList?.[`${value}Options`]
                                        )
                                        ? [
                                              {
                                                  subjectName: "",
                                                  hasEnglish: false,
                                                  hasAEO: false,
                                                  hasMath: false,
                                                  hasPutonghua: false,
                                              },
                                          ]
                                        : []
                                );
                                const initJobOptionsKeys =
                                    Object.keys(initJobOptions);
                                const isAllJobInput = initJobOptionsKeys?.every(
                                    (jobKey) =>
                                        getValues("job")?.find(
                                            (job) => job?.jobTitle === jobKey
                                        )
                                );
                                setDisablePostAddBtn(isAllJobInput);
                            }}
                            onOpen={(event) => {
                                const jobData = getValues("job");
                                const filterCurrentJobData = jobData?.filter(
                                    (job) => job?.jobTitle !== jobTitle
                                );
                                const filterDuplicatesOptions = {};
                                Object.keys(initJobOptions)?.map((jobKey) => {
                                    if (
                                        !filterCurrentJobData?.find(
                                            (job) => job?.jobTitle === jobKey
                                        )
                                    ) {
                                        filterDuplicatesOptions[jobKey] =
                                            initJobOptions[jobKey];
                                    }
                                });
                                setJobOptions(filterDuplicatesOptions);
                            }}
                        />
                    </Grid>
                    {/*<Grid item xs={2}>
                        <CustomCheckBox
                            label={t("Form101.label.publish")}
                            required={false}
                            control={control}
                            name={`job.${jobIndex}.isPublish`}
                            boxStyle={{
                                marginLeft: "-50px",
                            }}
                        />
                    </Grid>*/}
                </Grid>
            </Box>
            {Object.keys(subjectOptions)?.length ? (
                <Box mt={2}>
                    <TableContainer
                        component={Paper}
                        className={classes.subjectTableContainer}
                    >
                        {/* <Typography
                        className={[
                            classes.subjectTableTitle,
                            classes.blodText,
                        ]}
                    >
                        {t("Form101.label.supplementary")}
                    </Typography> */}
                        <Table
                            arial-label="subject table"
                            className={classes.subjectTable}
                            // style={{
                            //     tableLayout: "auto",
                            //     maxHeight: "500px",
                            //     overflow: "scroll",
                            // }}
                            stickyHeader
                        >
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        width={"20%"}
                                        className={classes.headNotBorder}
                                    ></TableCell>
                                    <TableCell
                                        width={"6%"}
                                        className={classes.headNotBorder}
                                    ></TableCell>
                                    <TableCell
                                        width={"15%"}
                                        align="center"
                                        className={classes.headNotBorder}
                                        colSpan={2}
                                    >
                                        <b>
                                            {t("Form101.label.supplementary")}
                                        </b>
                                    </TableCell>
                                    <TableCell
                                        width={"7%"}
                                        className={classes.headNotBorder}
                                    ></TableCell>
                                    <TableCell
                                        width={"5%"}
                                        className={classes.headNotBorder}
                                    ></TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell align="center" width={"20%"}>
                                        <b>{t("Form101.label.subject")}</b>
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        className={classes.headBorder}
                                        width={"6%"}
                                    >
                                        <b>{t("Form101.label.english")}</b>
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        className={classes.headBorder}
                                        width={"8%"}
                                    >
                                        <b>{t("Form101.label.otherEnglish")}</b>
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        className={classes.headBorder}
                                        width={"6%"}
                                    >
                                        <b>{t("Form101.label.math")}</b>
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        className={classes.headBorder}
                                        width={"6%"}
                                    >
                                        <b>{t("Form101.label.putonghua")}</b>
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        width={"5%"}
                                    ></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody className="subjects-table">
                                {getValues(`job.${jobIndex}.jobTitle`) ===
                                "AIG" ? (
                                    <>
                                        <TableRow>
                                            <TableCell colSpan={6}>
                                                <b>
                                                    {t(
                                                        "Form101.label.nonSpecialEducation"
                                                    )}
                                                </b>
                                            </TableCell>
                                        </TableRow>
                                        {nonSpecialEducationSubject?.map(
                                            (subject, index) => {
                                                return renderSubject(
                                                    subject,
                                                    subject?.currentIndex
                                                );
                                            }
                                        )}
                                        <TableRow>
                                            <TableCell
                                                colSpan={6}
                                                style={{ textAlign: "right" }}
                                            >
                                                <Button
                                                    onClick={() => {
                                                        append(
                                                            {
                                                                subjectName: "",
                                                                hasEnglish: false,
                                                                hasAEO: false,
                                                                hasMath: false,
                                                                hasPutonghua: false,
                                                                isSpecial: false,
                                                            },
                                                            {
                                                                shouldFocus: false,
                                                            }
                                                        );
                                                    }}
                                                    variant="contained"
                                                    color="primary"
                                                    aria-label="add"
                                                >
                                                    {t("common.button.append")}
                                                </Button>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={6}>
                                                <b>
                                                    {t(
                                                        "Form101.label.specialEducation"
                                                    )}
                                                </b>
                                            </TableCell>
                                        </TableRow>
                                        {specialEducationSubject?.map(
                                            (subject, index) => {
                                                return renderSubject(
                                                    subject,
                                                    subject?.currentIndex
                                                );
                                            }
                                        )}
                                        <TableRow>
                                            <TableCell
                                                colSpan={6}
                                                style={{ textAlign: "right" }}
                                            >
                                                <Button
                                                    onClick={() => {
                                                        append(
                                                            {
                                                                subjectName: "",
                                                                hasEnglish: false,
                                                                hasAEO: false,
                                                                hasMath: false,
                                                                hasPutonghua: false,
                                                                isSpecial: true,
                                                            },
                                                            {
                                                                shouldFocus: false,
                                                            }
                                                        );
                                                    }}
                                                    variant="contained"
                                                    color="primary"
                                                    aria-label="add"
                                                >
                                                    {t("common.button.append")}
                                                </Button>
                                            </TableCell>
                                        </TableRow>
                                    </>
                                ) : (
                                    fields?.map((subject, subjectIndex) => {
                                        return renderSubject(
                                            subject,
                                            subjectIndex
                                        );
                                    })
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {getValues(`job.${jobIndex}.subjectList`)?.length <
                        Object.keys(subjectOptions)?.length &&
                        getValues(`job.${jobIndex}.jobTitle`) !== "AIG" && (
                            <Box mt={6} style={{ textAlign: "right" }}>
                                <Button
                                    onClick={() => {
                                        append(
                                            {
                                                subjectName: "",
                                                hasEnglish: false,
                                                hasAEO: false,
                                                hasMath: false,
                                                hasPutonghua: false,
                                            },
                                            { shouldFocus: false }
                                        );
                                    }}
                                    variant="contained"
                                    color="primary"
                                    aria-label="add"
                                >
                                    {t("common.button.append")}
                                </Button>
                            </Box>
                        )}
                </Box>
            ) : null}
        </>
    );
}
